<template>
  <div :style="inputStyle">
    <input ref="input" type="text" :class="['form-control', size ? `form-control-${size}` : '']" :placeholder="placeholder" :disabled="disabled" />
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

export default {
  name: 'DatePicker',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'YYYY-MM-DD' },
    inputStyle: { type: String, default: '' },
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.fp = flatpickr(this.$refs.input, {
      dateFormat: 'Y-m-d',
      defaultDate: this.value || null,
      onChange: (selectedDates, dateStr) => {
        this.$emit('change', dateStr)
        this.$emit('input', dateStr)
      },
      allowInput: true,
    })
    if (this.disabled) this.fp.set('clickOpens', false)
  },
  watch: {
    value(v) {
      const current = this.fp.input.value
      if (v !== current) {
        this.fp.setDate(v || null, false)
      }
    },
    disabled(v) {
      this.fp.set('clickOpens', !v)
    },
  },
  beforeDestroy() {
    if (this.fp) this.fp.destroy()
  },
}
</script>



// WEBPACK FOOTER //
// src/DatePicker.vue